import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import InputLayout from "../components/InputLayout";
import ButtonLayout from "../components/ButtonLayout";
import ButtonLayoutMenu from "../components/ButtonLayoutMenu";

export default function (props) {
  return (
    <BackgroundUser scroll={true}>
      <Logo></Logo>
    </BackgroundUser>
  );
}
